import React from "react";
import { Link } from "react-router-dom";
import {
  FiArrowRight,
  FiFileText,
  FiMail,
  FiMapPin,
  FiPhone,
} from "react-icons/fi";
import heroPortrait from "../../Assets/hero-portrait.png";

const content = {
  zh: {
    eyebrow: "活動策劃 · 現場執行 · 客戶統籌",
    name: "盧碧香",
    englishName: "EUNICE LU",
    title: "把一場構想，\n穩穩帶到現場。",
    intro:
      "累計策劃及執行 150+ 場企業、政府及私人活動，從需求梳理、方案預算到供應商協調與現場交付，讓每個環節清晰、有序、準時落地。",
    work: "查看作品集",
    resume: "查看履歷",
    location: "現居香港 · 可即時全職投入",
    portraitLabel: "EVENT PLANNING / PRODUCTION / ON-SITE DELIVERY",
  },
  en: {
    eyebrow: "EVENT PLANNING · PRODUCTION · DELIVERY",
    name: "Eunice Lu",
    englishName: "BIXIANG LU",
    title: "Taking every idea\nconfidently to the floor.",
    intro:
      "Planned and delivered 150+ corporate, government and private events, from briefing, proposals and budgets to vendor coordination and on-site execution.",
    work: "View portfolio",
    resume: "View resume",
    location: "Based in Hong Kong · Available immediately",
    portraitLabel: "EVENT PLANNING / PRODUCTION / ON-SITE DELIVERY",
  },
};

function Home({ language }) {
  const copy = content[language];

  return (
    <main className="home-page">
      <section className="home-hero" id="home">
        <div className="home-dots" aria-hidden="true" />
        <div className="home-stage site-container">
          <div className="home-copy">
            <p className="hero-name-kicker">{copy.englishName}</p>
            <h1>{copy.name}</h1>
            <h2>{copy.title}</h2>
            <p className="hero-intro">{copy.intro}</p>
            <div className="hero-actions">
              <Link className="primary-action" to="/project">
                {copy.work}
                <FiArrowRight aria-hidden="true" />
              </Link>
              <Link className="secondary-action" to="/resume">
                <FiFileText aria-hidden="true" />
                {copy.resume}
              </Link>
            </div>
            <div className="home-contact-block">
              <p className="hero-location">
                <FiMapPin aria-hidden="true" />
                {copy.location}
              </p>
              <div className="contact-inline">
                <a href="mailto:eunicelu312@outlook.com">
                  <FiMail aria-hidden="true" />
                  eunicelu312@outlook.com
                </a>
                <a href="tel:+85266872763">
                  <FiPhone aria-hidden="true" />
                  +852 6687 2763
                </a>
              </div>
            </div>
          </div>

          <div className="home-portrait-stage">
            <img src={heroPortrait} alt={copy.name} className="home-portrait" />
          </div>
        </div>
      </section>
    </main>
  );
}

export default Home;
